/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/datatypes';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "team_api": {
        "nested": {
          "ListJobsRequest": {
            "fields": {
              "cursor": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              }
            }
          },
          "ListJobsResponse": {
            "fields": {
              "jobs": {
                "type": ".squareup.team_api.Job",
                "id": 1,
                "rule": "repeated"
              },
              "cursor": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "errors": {
                "type": ".squareup.connect.v2.resources.Error",
                "id": 3,
                "rule": "repeated"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.team_api?.nested?.ListJobsRequest && !$root.nested?.squareup?.nested?.team_api?.nested?.ListJobsResponse) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc Represents a [ListJobs](api-endpoint:Team-ListJobs) request.
 * --
 *
 * SOURCE ListJobsRequest @ squareup/team_api/endpoints/list-jobs.proto at 22:1
 */
export const ListJobsRequest = $root.lookupType('squareup.team_api.ListJobsRequest');
fixType(ListJobsRequest);
Builder.createAndAttachToType(ListJobsRequest);
/**
 * --
 * @desc Represents a [ListJobs](api-endpoint:Team-ListJobs) response. Either `jobs` or `errors`
 * is present in the response. If additional results are available, the `cursor` field is also present.
 * --
 *
 * SOURCE ListJobsResponse @ squareup/team_api/endpoints/list-jobs.proto at 37:1
 */
export const ListJobsResponse = $root.lookupType('squareup.team_api.ListJobsResponse');
fixType(ListJobsResponse);
Builder.createAndAttachToType(ListJobsResponse);